
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取模板集合
    GetTemplateTemplateSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Template/TemplateSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取模板类型集合
    GetTemplateTemplateTypeList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Template/GetTemplateTypeList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取已购买模板类型集合
    GetTemplateTemplateBuyList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Template/GetTemplateBuyList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 更新模板
    GetTemplateUseTemplateVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Template/UseTemplateVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 购买模板
    GetTemplateBuyTemplateVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Template/BuyTemplateVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
